export const rootPath = '/instruments/catalogue';
export const entityPath = '/instruments/catalogue:id';

export const addTitle = 'Add';
export const editTitle = 'Editing';
export const listTitle = 'Catalogue';
export const addButtonText = 'Register Instrument';
export const i18Namespace = 'Instrument';
export const defaultSort = '';
